<template>
  <v-switch
    :input-value="value"
    dense
    hide-details
    class="mt-0 pt-0"
    color="primary"
    label="تضمين التصنيفات المحذوفة في قائمة البحث"
    @change="$emit('input', $event)"
  />
</template>

<script>
export default {
  name: 'IncludeDeletedClassificationsToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
};
</script>
